export default __webpack_public_path__ + "static/media/left-arrow.a87cafa1.svg";